import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../integration-store';

export interface IAdyenBasicCredentials {
    merchant_id: string;
    live_prefix: string;
    api_key: string;
}

class AdyenBasicCredentialsStore implements ICredentialsStore {
    private _changes: IAdyenBasicCredentials = {} as IAdyenBasicCredentials;
    private _isSandbox = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get merchant_id() { return this._changes.merchant_id; }
    public get live_prefix() { return this._changes.live_prefix; }
    public get api_key() { return this._changes.api_key; }

    public set merchant_id(value: string) { this._changes.merchant_id = value; }
    public set live_prefix(value: string) { this._changes.live_prefix = value; }
    public set api_key(value: string) { this._changes.api_key = value; }

    public setIsSandbox(v: boolean) { this._isSandbox = v; }
    public get isSandbox(): boolean { return this._isSandbox; }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IAdyenBasicCredentials;
    }

    public getUpdatedModel(): IAdyenBasicCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default AdyenBasicCredentialsStore; 